import { type ReactNode } from "react";

type PageHeroProps = {
  eyebrow: string;
  title: ReactNode;
  description: string;
  children?: ReactNode;
  compact?: boolean;
};

const PageHero = ({ eyebrow, title, description, children, compact = false }: PageHeroProps) => (
  <section className={`page-hero${compact ? " page-hero-compact" : ""}`}>
    <div className="site-container page-hero-inner">
      <p className="eyebrow">{eyebrow}</p>
      <h1>{title}</h1>
      <p className="page-hero-lede">{description}</p>
      {children}
    </div>
  </section>
);

export default PageHero;
